import Box from "@ui-kit/layout/Box/Box.web";
import { useTranslation } from "next-i18next";
import { formatRelativeStaticPath } from "@shared/utils/images/utils";
import CardImage from "@shared/components/application/media/CardImage/CardImage.web";
import breakpoints from "@shared/theme/props/breakpoints";
import { PublicMembershipGroupSerializer } from "../../types";

const { sm, lg } = breakpoints;

export interface MembershipDetailsHeaderImageProps {
  membershipGroupData?: PublicMembershipGroupSerializer;
  imageWidth?: number;
  imageHeight?: number;
}

export const MembershipDetailsHeaderImage = ({
  membershipGroupData,
  imageWidth,
  imageHeight,
}: MembershipDetailsHeaderImageProps) => {
  const { t } = useTranslation("purchases");
  let src = formatRelativeStaticPath("images/default-banner.png");
  if (membershipGroupData?.image) {
    src = membershipGroupData.image;
  }

  const width = imageWidth
    ? { base: "100%", sm: `${imageWidth}px` }
    : { base: "100%", sm: "auto", lg: "100%" };
  const height = imageHeight
    ? { base: "100%", sm: `${imageHeight}px` }
    : { base: "100%", sm: "117px", lg: "100%" };

  return (
    <Box
      overflow="hidden"
      borderRadius={{ sm: "md" }}
      // eslint-disable-next-line
      css={{ aspectRatio: "2 / 1" } as any}
      w={width}
      h={height}
    >
      <CardImage
        src={src}
        width={imageWidth ?? 466}
        height={imageHeight ?? 233}
        alt={t("Event image for {{eventName}}", {
          eventName: membershipGroupData?.name,
        })}
        title={t("Event image for {{eventName}}", {
          eventName: membershipGroupData?.name,
        })}
        ariaLabel={t("Event image for {{eventName}}", {
          eventName: membershipGroupData?.name,
        })}
        sizes={`
          (max-width: ${sm}px) 100vw,
          ((min-width: ${sm}px) and (max-width: ${lg}px)) ${256}px,
          (min-width: ${lg}px) ${864}px,
        `}
        useServerlessResize
        aspectRatio="2"
      />
    </Box>
  );
};
